module.exports = __webpack_public_path__ + "static/media/NotoSansThai-Light.c6b75fbd.ttf";